// src/components/trades/components/PendingTab.js
//
// Extracted from inline definition in TradeCenter.js per Tier 2 #7
// commit 7a (refactor only — no behavior change).
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { dynastyTheme } from '../../../services/colorService';
import TradeProposalCard from './TradeProposalCard';

const PendingTab = ({ trades, highlightTradeId = null }) => {
  if (!trades || trades.length === 0) {
    return (
      <div className={`${dynastyTheme.classes.text.neutralLight} text-center py-12`}>
        <AlertCircle className="w-16 h-16 mx-auto mb-4 opacity-50" />
        <p className="text-lg font-medium">No trades pending approval</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {trades.map((trade) => (
        // Notification deep-link target (Bible § 4.5.12.2)
        <div
          key={trade.trade_id}
          id={`trade-${trade.trade_id}`}
          className={String(trade.trade_id) === String(highlightTradeId) ? 'ring-2 ring-yellow-400 rounded-lg' : ''}
        >
          <TradeProposalCard
            trade={trade}
            type="pending"
          />
        </div>
      ))}
    </div>
  );
};

export default PendingTab;
